import { mobileMenu, initializeMobileMenuHeight } from './front/header';

document.addEventListener( 'DOMContentLoaded', () => {

	mobileMenu();
	initializeMobileMenuHeight();

} );

import { contentScrollNav } from './front/components/content-scroll-nav'
contentScrollNav();

